import { useState } from "react";
import MUITable from "../../../../../../common/components/mui-table/mui-table";
import "./user-dashboard-keyresult-list.scss";
import DeleteConfirmationPopup from "../../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import CompanyDashboardEditKeyResultsPopup from "../../../../../company-dashboard/company-dashboard-all-objective/company-dashbaord-edit-popup/company-dashboard-edit-key-results-popup/company-dashboard-edit-key-results-popup";

const headers = [
  { key: "title", label: "Title" },
  { key: "assignedTo", label: "Assigned To" },
  { key: "startDate", label: "Start Date" },
  { key: "endDate", label: "End Date" },
  { key: "progress", label: "Progress" },
  { key: "status", label: "Status" },
];
const UserDashboardKeyresultList: any = (props: any) => {
  const {
    onRowClick,
    data,
    selectedKeyResult,
    employeesList,
    statusListKeyResults,
    handleEditKeyResult,
  } = props;
  const [isDeletePopupOpenKeyResult, setIsDeletePopupOpenKeyResult] =
    useState(false);
  const [deletePopupIdKeyResult, setDeletePopupIdKeyResult] =
    useState<any>(null);
  const [isOpenEditPopupKeyResult, setIsOpenEditPopupKeyResult] =
    useState(false);
  const handleCloseEditPopupKeyResult = () => {
    setIsOpenEditPopupKeyResult(false);
  };
  const handleDeleteKeyResult = async (deletePopupIdKeyresult: any) => {
    if (!deletePopupIdKeyresult) return;
    try {
      setIsDeletePopupOpenKeyResult(false);
      setDeletePopupIdKeyResult(null);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <div className="user-dashboard-keyresult-list-content">
        <MUITable
          columnNames={headers}
          rowsData={data}
          onRowClick={onRowClick}
          noRecordsTitle={"Please reload the page, or add new data."}
          noRecordsMessage={"Quiet zone! Nothing’s landed here for you yet."}
        />
      </div>
      <CompanyDashboardEditKeyResultsPopup
        isOpenAddPopup={isOpenEditPopupKeyResult}
        onCancel={handleCloseEditPopupKeyResult}
        employeesList={employeesList}
        statusListKeyResults={statusListKeyResults}
        selectedKeyResult={selectedKeyResult}
        onSave={handleEditKeyResult}
      />
      {isDeletePopupOpenKeyResult && (
        <DeleteConfirmationPopup
          isOpen={true}
          onClose={() => {
            setIsDeletePopupOpenKeyResult(false);
            setDeletePopupIdKeyResult(null);
          }}
          handleDelete={() => {
            handleDeleteKeyResult(deletePopupIdKeyResult);
            setIsDeletePopupOpenKeyResult(false);
          }}
          deleteId={deletePopupIdKeyResult}
        />
      )}
    </>
  );
};
export default UserDashboardKeyresultList;
